export const commitHash = '95c63c3';
export const buildDate = '2026-09-14T23:04:05Z';
export const googleAnalyticsToken = 'G-M60HG6T53W';
export const environment = 'PRODUCTION';
export const featureFlags = [
  'FEATURE_BENCHMARK_COMPARER',
  'FEATURE_GOROUTINES',
  'FEATURE_BENCHMARK_VISUALIZER',
  'FEATURE_LOG_VISUALIZER',
];
